import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2beb0b06"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Manager name")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Email")
], -1))
const _hoisted_3 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.managerRef,
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        name: "name"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_a_input, {
            type: "text",
            value: _ctx.managerRef.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.managerRef.name) = $event)),
            placeholder: "Manager name",
            class: "ant-input"
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { name: "email" }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createVNode(_component_a_input, {
            type: "text",
            class: "ant-input",
            placeholder: "Email",
            value: _ctx.managerRef.email,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.managerRef.email) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              style: {"margin-right":"10px"},
              type: "default",
              onClick: _ctx.onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Submit")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}